// tslint:disable: quotemark
export enum ImportHistoryStatusEnum {
	Processing = 0,
	ImportReceived = 1,
	ExcelReceived = 2,
	RenderComplete = 3,
	MailingComplete = 4,
	FileTooBig = -2,
	Failed = -1
}

export namespace ImportHistoryStatusEnum {
	export function toDescription(val: ImportHistoryStatusEnum) {
		switch (val) {
			case 0:
				return "Proccessing SFTP File";
			case 1:
				return "File received via SFTP";
			case 2:
				return "Excel uploaded after presort and Processing PDF";
			case 3:
				return "Rendered PDFs are available for download";
			case 4:
				return "All PDFs have been successfully mailed";
			case -2:
				return "The SFTP file is too large";
			case -1:
				return "There is a problem with the SFTP file";
		}
		return null;
	}
}
